export default __webpack_public_path__ + "static/media/okta.ad29ba5f.svg";